export const headerList = [
    {
        pageName: "Home",
        pageLink: "/"
    },
    {
        pageName: "Projects",
        pageLink: "/projects"
    },
    {
        pageName: "Blogs",
        pageLink: "/blogs"
    },
    {
        pageName: "Paintings",
        pageLink: "/paintings"
    }
];